import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfiguration } from '../models/app-configuration.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigurationService {
  private appConfig!: AppConfiguration;
  private readonly httpClient!: HttpClient;

  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  async loadAppConfig() {
    const data = await firstValueFrom(this.httpClient.get('./assets/app-config.json'));
    this.appConfig = data as AppConfiguration;
  }

  get config() {
    return this.appConfig;
  }
}
